<template>
    <div class="clearfix date-filter">
        <div v-for="option in filter.inputs.mode.options" :key="option.value">
            <div class="form-group">
                <label class="form-label label-auto" :for="option.name">
                    <input :id="option.value" v-model="mode" type="radio" :value="option.value" />
                    {{ option.label }}
                </label>
            </div>

            <div
                v-if="mode == 'smartdate' && option.value == mode"
                class="form-group form-group-32"
            >
                <div class="form-input block">
                    <select v-model="smartdate" class="wp-10" @change="updateView">
                        <option
                            v-for="opt in filter.inputs.smartdate.options"
                            :key="opt.value"
                            :value="opt.value"
                        >
                            {{ opt.label }}
                        </option>
                    </select>
                </div>
            </div>

            <div v-if="mode == 'between' && option.value == mode" class="form-group form-group-32">
                <el-date-picker
                    v-if="mode == 'between'"
                    v-bind="pickerOptions"
                    v-model="daterange"
                    class="wp-10"
                    type="daterange"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    :rangeSeparator="$t.__('common.labels.to')"
                    :startPlaceholder="$t.__('common.labels.start_date')"
                    :endPlaceholder="$t.__('common.labels.end_date')"
                    :defaultTime="defaultTime"
                />
            </div>

            <div v-if="showMinDate && option.value == mode" class="form-group form-group-32">
                <div class="form-input block">
                    <el-date-picker
                        v-bind="pickerOptions"
                        v-model="start"
                        valueFormat="YYYY-MM-DD"
                        :format="datePickerFormat"
                        type="date"
                        :placeholder="$t.__('listing.filters.DateFilter.choose_date')"
                    >
                    </el-date-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapState } = createNamespacedHelpers('corp');

export default {
    mixins: [ListingFilterMixin],

    data() {
        return {
            daterange: '',
            mode: '',
            smartdate: '',
            start: '',
            end: '',
            defaultTime: [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)],
        };
    },

    watch: {
        daterange(newval) {
            if (newval != null) {
                this.start = newval[0];
                this.end = newval[1];
            } else {
                this.start = '';
                this.end = '';
            }
        },
    },

    created() {
        if (this.mode == 'between' && this.start && this.end) {
            this.daterange = [this.start, this.end];
        }
    },

    computed: {
        showMinDate() {
            return this.mode == 'equals' || this.mode == 'after' || this.mode == 'before';
        },

        data() {
            return {
                mode: this.mode,
                smartdate: this.smartdate,
                start: this.start,
                end: this.end,
            };
        },

        pickerOptions() {
            return {
                firstDayOfWeek: this.timeformat == 'dmy' ? 1 : 7,
            };
        },

        ...mapGetters(['datePickerFormat']),

        ...mapState(['timeformat']),
    },

    methods: {
        updateView() {
            this.$forceUpdate();
        },
    },
};
</script>

<style lang="scss" scoped>
.date-filter {
    :deep(.el-date-editor) {
        .el-range-separator {
            height: auto;
        }
    }
}

.el-picker-panel__body {
    margin-left: 0px !important;
}
</style>
